export default __webpack_public_path__ + "static/media/ikotun-terminal.4025a690.png";